import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-stack-line",
    title: "资源丰富",
    desc: "汇集热门日剧与经典电影，类型覆盖悬疑、爱情、动画等。",
  },
  {
    icon: "ri-file-text-line",
    title: "简介清晰",
    desc: "每部作品配有完整剧情简介与元信息，追剧前先了解内容。",
  },
  {
    icon: "ri-heart-3-line",
    title: "一键收藏",
    desc: "喜欢的作品可加入收藏，基于本地存储随时找回。",
  },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-sparkling-2-line" aria-hidden="true"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专注日本影视的内容导航平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              「日本在线观看」致力于为喜爱日本电影与电视剧的观众，提供清晰、便捷的影视浏览体验。你可以按分类、地区、年份与类型快速筛选作品，查看剧情简介与封面信息，并用收藏功能记录追剧清单。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/category/series"
                className="flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                开始追剧
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 divide-y divide-background-200 border-t border-background-200 lg:border-l lg:border-t-0">
            {highlights.map((item) => (
              <div key={item.title} className="flex items-start gap-4 p-6 md:p-8">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}